import { GetUpperCase } from '../../../Public/Functions/GetUpperCase.js';
export const ButtonLink = (props) => {
    return (
        <div className="button-link">
            <a className="button" href={props.href} alt={props.name} title={props.name}>
                {GetUpperCase(props.name)}
            </a>
        </div>
    )
}